// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
:root {
  --primary-color: #1da1f2; /* Royal Blue */
  --secondary-color: #657786; /* Dark Grey */
  --button-hover-color: #1a91da; /* Slightly darker blue for hover */
}

body {
  font-family: Arial, sans-serif;
  background-color: #f5f8fa;
  color: var(--secondary-color);
  margin: 0;
  padding: 0;
}

.App {
  text-align: center;
  padding-bottom: 64px;
}

.App-logo {
  height: 80px;
  margin: 20px 0;
}

.App-header {
  background-color: var(--primary-color);
  min-height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

main {
  padding: 20px;
}

h1 {
  font-size: 1.5em;
  color: var(--primary-color);
}

/* 
input[type="text"] {
  width: 100%;
  margin: 10px 0;
  font-size: 1em;
  border: 1px solid var(--secondary-color);
  border-radius: 5px;
  outline: none;
  box-sizing: border-box;
}

input[type="text"]:focus {
  border-color: var(--primary-color);
} */
/* 
button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 25px;
  cursor: pointer;
  outline: none;
  transition: background-color 0.3s ease;
} */
/* button:hover {
  background-color: var(--button-hover-color);
}

button:disabled {
  background-color: var(--secondary-color);
  cursor: not-allowed;
} */
.SelectedLocation {
  margin-top: 20px;
  font-size: 1.2em;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,gBAAA;AAEA;EACE,wBAAA,EAAA,eAAA;EACA,0BAAA,EAAA,cAAA;EACA,6BAAA,EAAA,mCAAA;AAAF;;AAGA;EACE,8BAAA;EACA,yBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,kBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,YAAA;EACA,cAAA;AAAF;;AAGA;EACE,sCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,2BAAA;AAAF;;AAEA;;;;;;;;;;;;;GAAA;AAcA;;;;;;;;;;;GAAA;AAaA;;;;;;;GAAA;AASA;EACE,gBAAA;EACA,gBAAA;AADF","sourcesContent":["/* src/App.css */\n\n:root {\n  --primary-color: #1da1f2; /* Royal Blue */\n  --secondary-color: #657786; /* Dark Grey */\n  --button-hover-color: #1a91da; /* Slightly darker blue for hover */\n}\n\nbody {\n  font-family: Arial, sans-serif;\n  background-color: #f5f8fa;\n  color: var(--secondary-color);\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  text-align: center;\n  padding-bottom: 64px;\n}\n\n.App-logo {\n  height: 80px;\n  margin: 20px 0;\n}\n\n.App-header {\n  background-color: var(--primary-color);\n  min-height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\nmain {\n  padding: 20px;\n}\n\nh1 {\n  font-size: 1.5em;\n  color: var(--primary-color);\n}\n/* \ninput[type=\"text\"] {\n  width: 100%;\n  margin: 10px 0;\n  font-size: 1em;\n  border: 1px solid var(--secondary-color);\n  border-radius: 5px;\n  outline: none;\n  box-sizing: border-box;\n}\n\ninput[type=\"text\"]:focus {\n  border-color: var(--primary-color);\n} */\n/* \nbutton {\n  background-color: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 25px;\n  cursor: pointer;\n  outline: none;\n  transition: background-color 0.3s ease;\n} */\n\n/* button:hover {\n  background-color: var(--button-hover-color);\n}\n\nbutton:disabled {\n  background-color: var(--secondary-color);\n  cursor: not-allowed;\n} */\n\n.SelectedLocation {\n  margin-top: 20px;\n  font-size: 1.2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
